import { cmsGraphql, FragmentType, getFragmentData } from '../lib/cms/index.js'
import { createExtendedBlocks } from './Experiment/blocks.jsx'
import { Experiment, experimentBlockTypename } from './Experiment/index.jsx'

export const blocksWithExperimentFragment = cmsGraphql(/* GraphQL */ `
  fragment blocksWithExperimentFragment on CmsContentLayout {
    layout {
      __typename
      ...calculatorFragment
      ...callToActionBlockFragment
      ...devicePreviewFragment
      ...contentFragment
      ...archiveFragment
      ...quoteFragment
      ...crossLinksFragment
      ...accordionFragment
      ...featureSectionFragment
      ...carouselFragment
      ...bentoFragment
      ...priceTierFragment
      ...formBlockFragment
      ...resourcesFragment
      ...featureGridFragment
      ...disclaimersFragment
      ...legalBlockFragment
      ...videoBlockFragment
      ...richTextSectionFragment
      ...offerBlockFragment
      ...tableBlockFragment
      ...imageBlockFragment
      ...downloadBannerFragment
      ...calloutBlockFragment
      ...prosConsFragment
      ...videoEmbedBlockFragment
      ...richTextBlockFragment
      ...alertBannerBlockFragment
      ...experimentFragment
    }
  }
`)

const BlocksComponent = createExtendedBlocks({
  [experimentBlockTypename]: Experiment,
})

type BlocksProps = {
  data: FragmentType<typeof blocksWithExperimentFragment> | null | undefined
}

export const Blocks = ({ data }: BlocksProps) => {
  if (!data) {
    return null
  }

  const { layout } = getFragmentData(blocksWithExperimentFragment, data)

  return <BlocksComponent blocks={layout} />
}
